import axios from "axios";
import { V1_API_ORIGIN } from "./constants.config";

export const defaultPerPage = 20;
export const defaultCurrentPage = 1;
export const departmentId = 4
// export const apiUrl = "https://stage.eapi.equitypandit.in";
export const baseUrl = `${V1_API_ORIGIN}`;

export const api = async (url, payload = { params: {} }, method = "get") => {
    try {
        if (typeof axios.defaults.headers.common["Authorization"] == "undefined") {
            return false;
        }
        switch (method) {
            case "get":
                return await axios(`${baseUrl}${url}`, payload)
            case "post":
                return await axios.post(`${baseUrl}${url}`, payload)
            default:
                return false;
        }
    } catch (error) {
        return error?.response?.data;
    }
};